import Model from './model';
import JSONReader from 'utils/reader';
import User from './user';

export default class Post extends Model {
  static fields = [
    { name: 'id', defaultValue: 0 },
    'slug',
    'title',
    'excerpt',
    'html',
    { name: 'asset', mapping: (raw) => ({ type: raw.asset && raw.asset.type, url: raw.asset && raw.asset.url }), defaultValue: {} },
    { name: 'author', mapping: (raw) => JSONReader({ model: User }, raw.author), defaultValue: {} },
    { name: 'time', mapping: (raw) => (raw.time && raw.time.date || raw.time), defaultValue: '' },
    'published',
  ];
}
